import { getSetting } from "@/api/setting";
import { titleControl } from "@/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
    data: {
      skills: [],
      mainSkills: [],
    },
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async getSetting(ctx) {
      ctx.commit("setLoading", true);
      const data = await getSetting();
      ctx.commit("setData", data);
      ctx.commit("setLoading", false);
      if (data.favicon) {
        let link = document.querySelector("link[rel='shortcut icon']");
        if (link) {
          return;
        }
        link = document.createElement("link");
        link.rel = "shortcut icon";
        link.type = "image/x-icon";
        link.href = data.favicon;
        document.querySelector("head").appendChild(link);
      }
      if (data.siteTitle) {
        titleControl.setStoreTitle(data.siteTitle);
      }
    },
  },
  getters: {},
};
